import Swal from "sweetalert2";
import prices from "../../prices";
import { Product } from "../../../interfaces/Product";

/**
 * Helpers
 */
const fixed2 = (v: any): string => {
  const n = Number(String(v ?? "").replace(/[^0-9.-]+/g, ""));
  return (Number.isFinite(n) ? n : 0).toFixed(2);
};

const ceil0 = (v: any): number => Math.ceil(Number(v ?? 0) || 0);

const buildRow = (label: string, value: string | number = "", widthClass = "w-1/3") => `
  <div class="flex justify-between border-b border-gray-200 py-1">
    <span class="text-gray-600 font-medium ${widthClass} text-left">${label}:</span>
    <span class="w-fit text-left text-gray-800">${value}</span>
  </div>
`;

const sectionTitle = (title: string) => `
  <h3 class="text-center text-sm font-bold text-blue-700 mt-3 mb-1 border-b pb-1">${title}</h3>
`;

/**
 * API
 */
async function fetchProduct(axios: any, apiRoute: string, barra: string) {
  const token = localStorage.getItem("authToken") || "";
  return axios.get(`${apiRoute}/cat/showOne`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { barra },
  });
}

/**
 * HTML builder
 */
function buildProductHtml(item: Product, img: string, altimg: string): string {
  const precioBs = fixed2(prices.getPrecioNeto(item, null, true, true, true));
  const precioUsd = fixed2(prices.getPrecioNeto(item, item.prove_cfg?.FactorCambiario, true, true, true));

  const mejorPrecioBool = Boolean(item.dataprod?.mejor_precio_bool);
  const mejorPrecioValue = item.dataprod
    ? `${fixed2(item.dataprod?.mppBs)} - ${fixed2(item.dataprod?.mpp)}`
    : `${fixed2(item.precio1)} - ${fixed2((Number(item.precio1) || 0) / (item.prove_cfg?.FactorCambiario || 1))}`;

  const mejorPrecioBadge = mejorPrecioBool
    ? `<span class="text-green-600 font-bold">${mejorPrecioValue}</span>`
    : `<span class="text-red-600 font-bold">${mejorPrecioValue}</span>`;

  const ivaBadge = item.iva > 0 ? `+${fixed2(item.iva)}% IVA` : "";
  const daBadge = item.da > 0 ? `-${fixed2(item.da)}% DA` : "";

  return `
    <div class="max-w-lg mx-auto p-2 text-sm font-sans text-gray-800">
      <div class="text-center mb-3">
        <img
          src="${img}"
          alt="${altimg}"
          onerror="this.src='${altimg}'"
          class="rounded shadow max-h-28 mx-auto object-contain border border-gray-300"
        />
      </div>

      <div class="bg-white rounded-md border p-3 space-y-2">

        ${sectionTitle("Información general")}
        ${buildRow("Descripción", item.desprod)}
        ${buildRow("Marca", item.marca)}
        ${buildRow("Molécula", item.molecula || "")}
        ${buildRow("Código de barra", item.barra)}
        ${buildRow("Código", item.codprod || "")}

        ${sectionTitle("Precios y descuentos")}
        ${buildRow("Precio", `Bs ${precioBs} / $ ${precioUsd}`)}
        ${buildRow("Mejor precio", mejorPrecioBadge)}
        ${ivaBadge ? buildRow("IVA", ivaBadge) : ""}
        ${daBadge ? buildRow("DA", daBadge) : ""}
        ${buildRow("DN (Descuento Marca)", `${fixed2(item?.discountMarca)}%`, "w-fit")}
        ${buildRow("DP (Descuento Producto)", `${fixed2(item?.discountItem)}%`, "w-fit")}

        ${sectionTitle("Inventario")}
        ${buildRow("Disponible", Number(item.cantidad || 0))}
        ${buildRow("Consolidado", Number(item.dataprod?.invConsol || 0))}
        ${buildRow("En tránsito", Number(item.transito || 0))}
        ${buildRow("Vendidas (ultimos 30 dias)", Number(item.und_vendidas || 0))}

        ${sectionTitle("Lote y logística")}
        ${buildRow("Lote", `${item.lote} | ${item.fecvence}`)}
        ${buildRow("Unidad por bulto", (item.tpmBulto > 0 ? item.tpmBulto : item.bulto) || 0)}

        ${sectionTitle("Consumo y sugerido")}
        ${buildRow("VMD", fixed2(item.vmd))}
        ${buildRow("Sugerido 15 días", ceil0(item.sug15))}
        ${buildRow("Sugerido 30 días", ceil0(item.sug30))}
        ${buildRow("Sugerido 60 días", ceil0(item.sug60))}

      </div>
    </div>
  `;
}

/**
 * Modal
 */
export default async function openProductModal(
  axios: any,
  apiRoute: string,
  barra: string,
  img: string,
  altimg: string
) {
  try {
    Swal.showLoading();

    const response = await fetchProduct(axios, apiRoute, barra);
    const html = buildProductHtml(response.data, img, altimg);

    Swal.fire({
      title: "INFORMACION DEL PRODUCTO",
      html,
      showCloseButton: true,
      showConfirmButton: false,
      focusConfirm: false,
      customClass: { popup: "swal2-popup swal2-modal swal2-show w-max" },
    });
  } catch (err) {
    console.log(err);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "No se pudo cargar la información del producto.",
      showCloseButton: true,
    });
  }
}
